
import { useState } from 'react';
import { toast } from 'sonner';
import { importAnkiQuestions, deleteExistingAnkiQuestions } from '@/services/anki-service';

export function useImportAnki() {
  const [isImporting, setIsImporting] = useState(false);
  const [importStats, setImportStats] = useState<{
    total: number;
    imported: number;
    rejected: number;
    rejectionReasons: Record<string, number>;
  } | null>(null);

  const importAnki = async (
    subject: string,
    file?: File,
    importDate?: Date,
    timePeriod?: string
  ) => {
    if (!file) {
      toast.error('No file selected');
      return false;
    }

    setIsImporting(true);
    try {
      console.log(`Starting import for subject: ${subject} with file: ${file.name}${importDate ? `, date: ${importDate.toISOString().split('T')[0]}` : ''}${timePeriod ? `, time period: ${timePeriod}` : ''}`);
      
      const result = await importAnkiQuestions(
        file,
        subject,
        importDate,
        timePeriod
      );
      
      console.log(`Import complete. Added ${result.importedCount} questions.`);
      
      setImportStats({
        total: result.totalProcessed,
        imported: result.importedCount,
        rejected: result.errors.length,
        rejectionReasons: result.rejectionReasons || {}
      });
      
      if (result.errors.length > 0) {
        console.warn(`There were ${result.errors.length} errors during import`);
        toast.warning(`Import completed with ${result.errors.length} rejected questions`, {
          description: "Some lines could not be parsed or had quality issues"
        });
      } else {
        toast.success(`Successfully imported ${result.importedCount} questions for ${subject}${importDate ? ` (${importDate.toISOString().split('T')[0]})` : ''}${timePeriod ? ` [${timePeriod}]` : ''}`);
      }
      
      return true;
    } catch (error) {
      console.error('Error importing Anki deck:', error);
      toast.error('Failed to import Anki deck', {
        description: error instanceof Error ? error.message : 'Unknown error occurred'
      });
      return false;
    } finally {
      setIsImporting(false);
    }
  };
  
  const clearImportStats = () => {
    setImportStats(null);
  };

  return { importAnki, isImporting, importStats, clearImportStats };
}
